import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import '../styles/header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <NavLink to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
            <img src={logo} alt="Integritz Technologies" />
            <span className="company-name">INTEGRITZ TECHNOLOGIES</span>
          </NavLink>

          <button className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={isMenuOpen ? 'nav-open' : ''}>
            <ul className="nav">
              <li><NavLink to="/" onClick={() => setIsMenuOpen(false)}>Home</NavLink></li>
              <li><NavLink to="/about" onClick={() => setIsMenuOpen(false)}>About Us</NavLink></li>
              <li><NavLink to="/services" onClick={() => setIsMenuOpen(false)}>Our Services & Solutions</NavLink></li>
              <li><NavLink to="/why-choose-us" onClick={() => setIsMenuOpen(false)}>Why Choose Us</NavLink></li>
              <li><NavLink to="/career" onClick={() => setIsMenuOpen(false)}>Career</NavLink></li>
              <li><NavLink to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</NavLink></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
